import LintasAPIService from '../../APIServices/lintasapi';
import { SERVER_CHECK, TOGGLE_STATUS, SHOW_TOAST } from '../actionTypes';

const apiCall = new LintasAPIService();

export const getServerState = () => (dispatch) => {
  apiCall
    .checkServerStatus()
    .then((response) => dispatch({
      type: SERVER_CHECK,
      payload: response.data.status,
    }))
    .catch(() => {
      // handle err
      // console.log('err', err);
    });
};

export const toggleDrawer = (newState) => ({
  type: TOGGLE_STATUS,
  newState,
});

export const showToastAction = (text, toastType) => ({
  type: SHOW_TOAST,
  text,
  toastType,
});
